import { render, staticRenderFns } from "./configuration-fields-translations.vue?vue&type=template&id=7071c446&scoped=true&"
import script from "./configuration-fields-translations.ts?vue&type=script&lang=ts&"
export * from "./configuration-fields-translations.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-fields-translations.scss?vue&type=style&index=0&id=7071c446&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7071c446",
  null
  
)

export default component.exports